<h3 mat-dialog-title>{{'FORM.gameOriginFormDialog.gameOriginForm' | translate}}</h3>

<mat-dialog-content class="mat-typography">
  <div id="tagid-info" class="mb-2">
    <div class="d-flex flex-column align-items-start">
      <span class="font-weight-bold font-italic">{{infoGameRecord.hunter}}</span>
      <span class="font-weight-light">{{infoGameRecord.tagid}}</span>
      <span class="text-muted">{{infoGameRecord.species}}</span>
    </div>
  </div>

  <div class="py-2">
    <span>{{'FORM.gameOriginFormDialog.gameOriginFormTemplate' | translate}} </span>
    <div class="py-2">
      <form [formGroup]="gameOriginForm">
        <mat-form-field class="w-100">
          <mat-label>{{'COCKPIT.template' | translate }}</mat-label>
          <mat-select formControlName="template" name="context">
            <mat-option *ngFor="let template of templatesList" [value]="template.file">{{template.name}}</mat-option>
          </mat-select>
        </mat-form-field>
      </form>
    </div>
  </div>


  
    <form [formGroup]="templateDataForm">
      <div *ngFor="let section of gameOriginDataFields">
        <span>{{section.title}}</span>
        <div class="list-group">
          <div *ngFor=" let row of section?.rows" class="list-group-item">
            <div class=" d-flex flex-row align-items-center justify-content-between">
              <span *ngIf="row.type!='text'">{{row.title}}</span>

              <div *ngIf="row.type=='options'">
                <mat-button-toggle-group formControlName="{{row.key}}" aria-label="Font Style">
                  <mat-button-toggle *ngFor="let option of row?.options" value="{{option}}">{{option}}</mat-button-toggle>
                </mat-button-toggle-group>
              </div>
  
              <div *ngIf="row.type=='boolean'">
                <mat-slide-toggle formControlName="{{row.key}}"></mat-slide-toggle>
              </div>

              <mat-form-field class="w-100" *ngIf="row.type=='text'">
                <mat-label>{{row.title}}</mat-label>
                <input matInput type="text" formControlName="{{row.key}}">
              </mat-form-field>
  
            </div>
    
          </div>
        </div>
       
  
      </div>
    </form>

</mat-dialog-content>


<div mat-dialog-actions>
  <button mat-button class="second-btn" (click)="onCancle()" [hidden]="!data.cancleCallback">{{'gen_dialog_btn_cancle' | translate}}</button>
  <button mat-button class="first-btn" cdkFocusInitial (click)="onConfirm()">{{'gen_dialog_btn_ok' | translate}}</button>
</div>